import React, { useLayoutEffect, useEffect, useState } from "react";
import { MdSunny } from "react-icons/md";
import { FaDesktop, FaMoon } from "react-icons/fa";
import { isFunctionalCookieAllowed } from "../utils/langCookie";

const THEME_KEY = "theme";

const isFunctionalAllowed = () => isFunctionalCookieAllowed();


const getInitialMode = () => {
  if (typeof window === "undefined") return "system";

  // ❌ Không cho đọc localStorage
  if (!isFunctionalAllowed()) {
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" : "light";
  }

  const stored = localStorage.getItem(THEME_KEY);
  if (stored === "light" || stored === "dark" || stored === "system") {
    return stored;
  }

  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
};


const ThemeToggle = () => {
  const [mode, setMode] = useState(getInitialMode);
  const [isDark, setIsDark] = useState(
    () => typeof document !== "undefined" && document.documentElement.classList.contains("dark")
  );

  useLayoutEffect(() => {
    const root = document.documentElement;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");

    const prefersDark = mq.matches;
    const shouldUseDark =
      mode === "dark" || (mode === "system" && prefersDark);

    root.classList.toggle("dark", shouldUseDark);
    root.style.colorScheme = shouldUseDark ? "dark" : "light";
    setIsDark(shouldUseDark);

    // ❌ KHÔNG ĐƯỢC LƯU
    if (!isFunctionalAllowed()) {
      localStorage.removeItem(THEME_KEY);
    } else {
      localStorage.setItem(THEME_KEY, mode);
    }

    // favicon
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = shouldUseDark
        ? "/GoPaperlessAgentDark.svg"
        : "/GoPaperlessAgentMobile.svg";
    }

    if (mode === "system") {
      const listener = (e) => {
        const useDark = e.matches;
        root.classList.toggle("dark", useDark);
        root.style.colorScheme = useDark ? "dark" : "light";
        setIsDark(useDark);
      };

      mq.addEventListener("change", listener);
      return () => mq.removeEventListener("change", listener);
    }
  }, [mode]);

  useEffect(() => {
    const handleConsentChange = () => {
      if (!isFunctionalAllowed()) {
        localStorage.removeItem(THEME_KEY);
        setMode("system"); // hoặc "light" nếu muốn
      }
    };

    window.addEventListener("cookie-consent-changed", handleConsentChange);
    return () =>
      window.removeEventListener("cookie-consent-changed", handleConsentChange);
  }, []);


  const btn = (key, IconComponent, label) => {
    const iconColor =
      isDark && mode === key ? "text-white" : "text-[#4B5563]";

    return (
      <button
        type="button"
        onClick={() => setMode(key)}
        className={`
          w-10 h-10 p-2 transition 
          flex items-center justify-center
          ${mode === key
            ? "bg-slate-300 dark:bg-slate-700 dark:border-slate-500"
            : "bg-transparent hover:bg-slate-200 dark:hover:bg-slate-700"
          }
        `}
        title={label}
      >
        <IconComponent className={`text-[20px] text-[#64748B] ${iconColor}`} />
      </button>
    );
  };

  return (
    <div className="flex gap-3 py-3">
      {btn("light", MdSunny, "Light")}
      {btn("system", FaDesktop, "System")}
      {btn("dark", FaMoon, "Dark")}
    </div>
  );
};

export default ThemeToggle;
